import { SplendidCRMDFService } from './../services/SplendidCRMDFService';
import { Component }        from '@angular/core';
import { Headers, RequestOptions, Http} from  '@angular/http';
import { Router }             from '@angular/router';
import * as constants from '../config/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';

import { User } from '../models/Users';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./style.css'],
})


export class LoginComponent {
    message:string = '';
    _VERSION:string = constants.VERSION;

    public options = {
      position: ["bottom", "left"],
      timeOut: 5000,
      lastOnBottom: true
    }

    public loginForm: FormGroup;
    private currentUser : User;
    constructor (
        private _http : Http, 
        private formBuilder: FormBuilder, 
        private _router: Router, 
        private _notificationsService: NotificationsService,
        private splendidService: SplendidCRMDFService,
        private loadinService: NgxSpinnerService) {
        this.loginForm = formBuilder.group({
            UserName: ['', Validators.required],
            Password: ['', Validators.required]
        });
    }

    private storeToken(data) {
        //this.currentUser = data;
        //console.log(JSON.stringify(data));
        localStorage.setItem('session', JSON.stringify(data));
        this._router.navigate(['/calendario']);
    }

    //TODO reenviar al dashboard
    formSubmit() {
        var queryHeaders = new Headers();
        queryHeaders.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: queryHeaders, withCredentials: true });
        this.loadinService.show();
        try {

        
        this._http.post(constants.SPLENDID_INSTANCE_URL + 'Login', JSON.stringify(this.loginForm.value), options)
            .subscribe((data) => {
                this.splendidService.setIsLogued(true);
                // recupera el perfil del usuario que ingresó
                this.splendidService.getProfile().subscribe((response:any)=> {
                    let result = JSON.parse(response._body);
                    let userP = User.fromJson(result);      
                    this.storeToken(userP);                                                                                                                                                                             
                    this.splendidService.setUserProfile(userP);
                    this.splendidService.queryAccounts().subscribe((accounts) => {
                        this.splendidService.setAccouts(accounts);
                    });
                    this.loadinService.hide();
                    this._router.navigate(['/calendario']);
                });
            }, (error) => {
                this.splendidService.setIsLogued(false);
                let result = JSON.parse(error._body);
                this.loadinService.hide();
                //this.notificationService.show('error', error.json().error.message);
                this._notificationsService.error(
                    'Error de autenticación',
                    result.Message,
                    {
                        timeOut: 5000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: false
                    }
                )
            });
        } catch(error) {
            console.log(error);
        }
    }

    public logout() {
        //console.log();
        localStorage.setItem('session_token', '');
        localStorage.setItem('role', '');
        //window.location.hash='login';
        this._router.navigate(['login']);
        this.splendidService.setIsLogued(false);
    }

    // public getCurrentUser(): User {
    //     return this.currentUser;
    // }
}



// WEBPACK FOOTER //
// /app/src/app/login/login.component.ts